import Chip from '@components/Chip';
import Column from '@components/Column';
import PrepaidContext from '@components/prepaid/PrepaidProvider/PrepaidContext';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const examples: number[] = [1, 2, 3, 5];

interface Props {
    initialAmount?: number;
}

function PrepaidCardAmount({ initialAmount }:Props) {
    const { t } = useTranslation('prepaidCard');
    const [isManual, setIsManual] = useState<boolean>(false);
    const { amount, setAmount } = useContext(PrepaidContext);
    useEffect(() => {
        if (initialAmount) {
            setAmount(initialAmount / 10000);
        }
    }, [initialAmount]);
    return (
        <Container fullWidth>
            <Text size='2xl'
                fontWeight='bold'
                color={colors.gray7}>
                {t('components.amount.title')}
            </Text>
            <AmountList>
                {examples.map((value) => (
                    <Chip key={`amount ${value}`}
                        isSelected={amount === value && !isManual}
                        onClick={() => {
                            setAmount(value);
                            setIsManual(false);
                        }} >
                        {value}{t('components.amount.tenThousandUnit')}
                    </Chip>
                ))}
                <Chip isSelected={isManual}
                    onClick={() => setIsManual(true)} >
                    {t('components.amount.manualInput')}
                </Chip>
            </AmountList>
            {isManual && (
                <ManualInput fullWidth spacing={10}>
                    <Row fullWidth spacing={12}>
                        <TextField placeholder={t('components.amount.placeholder')}
                            value={amount.toString()}
                            onChange={(e) => setAmount(Number(e.target.value))}
                            max={50}
                            min={1}
                            // @ts-ignore
                            type='number'
                            inputMode='numeric' />
                        <Text size='xl' fontWeight='bold' color={colors.gray7}>
                            {t('components.amount.tenThousandUnit')}
                        </Text>
                    </Row>
                    <Text size='s' fontWeight='bold' color={colors.gray5}>
                        {t('components.amount.maxInfo')}
                    </Text>
                </ManualInput>
            )}
        </Container>
    );
}

const Container = styled(Column)`
    padding: 40px 20px 30px;
`;

const AmountList = styled(Chip.Container)`
    margin-top: 24px;
`;

const ManualInput = styled(Column)`
    margin-top: 20px;
`;

export default PrepaidCardAmount;
